export const GUARANTEE_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
  category: {
    isRequiredTrim: {
      value: true,
    },
  },
  shortName: {},
  isQuebecHealthPremium: {
    mutuallyExclusiveWith: {
      value: {
        other: "isTaxableBenefitsProvincial",
        customMessageKey: "admin.guarantees.form.errors.quebecAndOutOfQuebec",
      },
    },
  },
  isTaxableBenefitsProvincial: {
    mutuallyExclusiveWith: {
      value: {
        other: "isQuebecHealthPremium",
        customMessageKey: "admin.guarantees.form.errors.quebecAndOutOfQuebec",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/guaranteeValidationRules.js